<template>

   <div>
        <section v-touch:swipe="swipeHandler">
            <div v-if="designdata" class="emoji-grid owl-carousel owl-theme owl-loaded">
                <div class="owl-stage-outer">
                    <div class="owl-item" style="left: -50%; text-align: left; float: right;">
                        <div class="item pl-2 pr-2" style="position: relative; left: 50%;" v-on:click="$emit('select-design', design)"
                             v-bind:data-designname="design.name" v-bind:key="design.name" v-for="design in designdata.designs">
                            <img v-show="design.name === designdata.designs[selectedIdx].name" style="max-width: 400px;" v-bind:id="design.name" v-bind:src="designdata.base + design.name + '/' + design.selectionImage" v-bind:alt="design.name">
                        </div>
                    </div>
                </div>

                <div class="owl-nav">
                    <button type="button" role="presentation" class="owl-prev" v-on:click="prevIdx()">
                        <span class="fa fa-chevron-left"></span>
                    </button>
                    <button type="button" role="presentation" class="owl-next" v-on:click="nextIdx()">
                        <span class="fa fa-chevron-right"></span>
                    </button>
                </div>

                <div class="owl-dots">
                    <button v-bind:key="page" v-for="page in designdata.designs.length" v-on:click="toPage(selectedIdx = page - 1)" role="button" v-bind:class="['owl-dot', selectedIdx == (page - 1) ? 'active' : '']"><span></span></button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: 'DesignSection',

    data: function () {
        return {
            pageNumber: 0,
        }
    },

    props: {
        designdata: Object,
        selectedIdx: Number,
    },

    methods: {

        swipeHandler(direction) {
            if (direction === "left") {
                this.nextIdx();
            }
            else if(direction === "right") {
                this.prevIdx();
            }            
        },

        nextIdx() {
            this.selectedIdx++;
            if (this.selectedIdx === this.designdata.designs.length) {
                this.selectedIdx = 0;
            }
            this.$emit('select-design', this.selectedIdx)
        },

        toPage(idx) {
          this.selectedIdx = idx;
          this.$emit('select-design', this.selectedIdx)
        },

        prevIdx() {
            if (this.selectedIdx === 0) {
                this.selectedIdx = this.designdata.designs.length - 1;
            } else {
                this.selectedIdx--;
            }
            this.$emit('select-design', this.selectedIdx)
        },

    },


    computed: {

    }

}
</script>
